export default __webpack_public_path__ + "static/media/rtx3080.dc856366.jpg";